import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
  min-height: 100vh;
  background: #667eea;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
`;

const Card = styled.div`
  background: white;
  padding: 60px 40px;
  border-radius: 0;
  text-align: center;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
`;

const Title = styled.h1`
  color: #2d3748;
  margin-bottom: 10px;
  font-size: 2.5rem;
  font-weight: 700;
`;

const Subtitle = styled.p`
  color: #718096;
  margin-bottom: 40px;
  font-size: 1.2rem;
`;

const RoomID = styled.div`
  background: #f7fafc;
  padding: 15px 25px;
  border-radius: 8px;
  margin-bottom: 40px;
  border: 1px solid #e2e8f0;
`;

const RoomIDLabel = styled.span`
  color: #4a5568;
  font-weight: 600;
  margin-right: 10px;
`;

const RoomIDValue = styled.span`
  color: #667eea;
  font-weight: 700;
  font-size: 1.1rem;
`;

const Form = styled.form`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Input = styled.input`
  width: 100%;
  padding: 16px 20px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.2s ease;
  background: white;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #667eea;
  }

  &::placeholder {
    color: #a0aec0;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 16px;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #45a049;
  }
`;

const JoinRoom = () => {
  const [username, setUsername] = useState("");
  const history = useHistory();
  const { roomID } = useParams();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!username.trim()) {
      alert("Please enter your name");
      return;
    }

    localStorage.setItem("username", username);
    history.push(`/room/${roomID}`);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  return (
    <Container>
      <Card>
        <Title>Join Meeting</Title>
        <Subtitle>Enter your name to continue</Subtitle>

        <RoomID>
          <RoomIDLabel>Room ID:</RoomIDLabel>
          <RoomIDValue>{roomID}</RoomIDValue>
        </RoomID>

        <Form onSubmit={handleSubmit}>
          <Input
            type="text"
            placeholder="Enter your name"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyPress={handleKeyPress}
            autoFocus
          />

          <Button type="submit">Join Room</Button>
        </Form>
      </Card>
    </Container>
  );
};

export default JoinRoom;
